export const StageTenApiVersions = {
  "2023-03": {
    supported: true,
  },
}
